import { render } from "./nativeAppHeader.vue?vue&type=template&id=ca74ac3c&scoped=true&ts=true"
import script from "./nativeAppHeader.vue?vue&type=script&lang=ts"
export * from "./nativeAppHeader.vue?vue&type=script&lang=ts"

import "./nativeAppHeader.vue?vue&type=style&index=0&id=ca74ac3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca74ac3c"],['__file',"src/components/layout/nativeAppHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca74ac3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca74ac3c', __exports__)) {
    api.reload('ca74ac3c', __exports__)
  }
  
  module.hot.accept("./nativeAppHeader.vue?vue&type=template&id=ca74ac3c&scoped=true&ts=true", () => {
    api.rerender('ca74ac3c', render)
  })

}


export default __exports__